function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScNavHome = function SvgScNavHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43597 3.18404C1 4.03969 1 5.15979 1 7.4V16.6C1 18.8402 1 19.9603 1.43597 20.816C1.81947 21.5686 2.43139 22.1805 3.18404 22.564C4.03969 23 5.15979 23 7.4 23H16.6C18.8402 23 19.9603 23 20.816 22.564C21.5686 22.1805 22.1805 21.5686 22.564 20.816C23 19.9603 23 18.8402 23 16.6V7.4C23 5.15979 23 4.03969 22.564 3.18404C22.1805 2.43139 21.5686 1.81947 20.816 1.43597C19.9603 1 18.8402 1 16.6 1H7.4C5.15979 1 4.03969 1 3.18404 1.43597C2.43139 1.81947 1.81947 2.43139 1.43597 3.18404ZM13.4142 4.5C12.6332 3.71895 11.3668 3.71895 10.5858 4.5L5.29289 9.79289L3.29289 11.7929L4.70711 13.2071L5 12.9142V18.5V19.5H6H11H13H18H19V18.5V12.9142L19.2929 13.2071L20.7071 11.7929L18.7071 9.7929L13.4142 4.5ZM7 17.5V10.9142L12 5.91421L17 10.9142V17.5H14V14V13H13H11H10V14V17.5H7Z",
    fill: "var(--on-surface)",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }));
};
export default SvgScNavHome;